import React, { ReactNode, useState } from 'react';
import carouselCurrentSvg from '../../Assets/Icons/carouselCurrent.svg';
import carouselNextSvg from '../../Assets/Icons/carouselNext.svg';
import chartArrowLeftSvg from '../../Assets/Icons/chartArrowLeft.svg';
import chartArrowRightSvg from '../../Assets/Icons/chartArrowRight.svg';
import { EventActionsEnum, EventCategoriesEnum } from '../../Services/Logging/DataLayerDefinitions';
import loggingService from '../../Services/Logging/LoggingService';
import trackingService, { TrackingEvent } from '../../Services/Tracking/TrackingService';
import styles from './Carousel.module.scss';

interface ICarouselProps {
    children?: ReactNode[];
    track: TrackingEvent;
}

const Carousel = (props: ICarouselProps) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const validChildren = React.Children.toArray(props.children)
        .filter(Boolean)
        .map((x, index) => ({ id: `CarouselChild_${index}`, value: x }));

    const numberOfItems = validChildren.length;

    const handleNext = () => {
        const nextIndex = (currentIndex + 1) % numberOfItems;
        setCurrentIndex(nextIndex);
        loggingService.trackEventWithAnalytics(EventActionsEnum.ButtonClick, EventCategoriesEnum.CarouselNext, `Next Index: ${nextIndex}`);
        trackingService.track({ ...props.track, eventValue: `VisibleChart${nextIndex + 1}` });
    };

    const handlePrevious = () => {
        const prevIndex = (currentIndex - 1 + numberOfItems) % numberOfItems;
        setCurrentIndex(prevIndex);
        loggingService.trackEventWithAnalytics(EventActionsEnum.ButtonClick, EventCategoriesEnum.CarouselPrevious, `Previous Index: ${prevIndex}`);
        trackingService.track({ ...props.track, eventValue: `VisibleChart${prevIndex + 1}` });
    };

    return (
        <div className={styles.carousel}>
            <div>{validChildren[currentIndex].value}</div>
            <div className={styles.carousel_buttons}>
                <button type="button" className={styles.carousel_button} onClick={handlePrevious}>
                    <img src={chartArrowLeftSvg} alt="" />
                </button>
                <div>
                    {validChildren.map((x, index) => {
                        if (index === currentIndex) {
                            return <img className={styles.carousel_position_dots} src={carouselCurrentSvg} key={x.id} alt="#" />;
                        }

                        return <img className={styles.carousel_position_dots} src={carouselNextSvg} key={x.id} alt="#" />;
                    })}
                </div>
                <button type="button" className={styles.carousel_button} onClick={handleNext}>
                    <img src={chartArrowRightSvg} alt="" />
                </button>
            </div>
        </div>
    );
};

export default Carousel;
